// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2YIqb","notes":"Notes_notes__3Sggd","note":"Notes_note__2EGH9","markdown":"Notes_markdown__20SmN"};